import { FmvFeed } from "../../interfaces/feed.model";
import { WizardStep } from "../../interfaces/feed.model";
import { FeedWizard } from "../../models/feed-wizard.base";

export class FmvFeedWizard extends FeedWizard {
  getPluginSteps() {
    return [{ name: 'Configure FMV', template: '', component: null }];
  }

  createFeed(
    name: string,
    defaultFeedOptions: { autostart: boolean },
    customFeedOptions: { ipaddr: string; videoType: string },
  ): void {
    const feed = new FmvFeed(
      name,
      'assets/img/fmvfeed.svg',
      defaultFeedOptions.autostart,
      customFeedOptions.ipaddr,
      customFeedOptions.videoType
    );
    this.addToFeedService(feed);
  }
}

export class FmvFeedType {
  getId() {
    return 'fmv';
  }

  getName() {
    return 'FMV Feed';
  }

  getIcon() {
    return 'assets/img/fmvfeed.svg';
  }

  getWizard() {
    const wizard = new FmvFeedWizard();
    return wizard;
  }
}
